import { render } from "./Addressee.vue?vue&type=template&id=12742bac"
import script from "./Addressee.vue?vue&type=script&lang=js"
export * from "./Addressee.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__